import React from 'react';
import { UserIcon } from '@heroicons/react/24/outline';

const Members: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Members</h1>
      <p className="section-description">
        Manage member accounts with comprehensive profile management, subscription tracking, and activity monitoring.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <UserIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Member Management</h3>
              <p className="feature-description">
                Handle member accounts with the following capabilities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create and edit member profiles</li>
                <li>Manage member information</li>
                <li>Set member passwords</li>
                <li>Delete individual members</li>
                <li>Bulk delete multiple members</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <UserIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Profile Information</h3>
              <p className="feature-description">
                Manage comprehensive member details:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Name and email</li>
                <li>Phone number</li>
                <li>About information</li>
                <li>Address details</li>
                <li>City information</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <UserIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Subscription Management</h3>
              <p className="feature-description">
                Handle member subscriptions:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Subscription plan selection</li>
                <li>Expiration date tracking</li>
                <li>Plan status monitoring</li>
                <li>Subscription history</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <UserIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Member List</h3>
              <p className="feature-description">
                View and manage members in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Name (searchable, sortable)</li>
                <li>Email (searchable, sortable)</li>
                <li>Phone (searchable, sortable)</li>
                <li>City (searchable, sortable)</li>
                <li>Subscription plan (sortable)</li>
                <li>Subscription expiration (sortable)</li>
                <li>Events count (sortable)</li>
                <li>Creation date (sortable)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Keep member information up to date</li>
            <li>Regularly review subscription status</li>
            <li>Monitor member activity</li>
            <li>Maintain secure password policies</li>
            <li>Track subscription expirations</li>
            <li>Update member profiles regularly</li>
            <li>Archive inactive members</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Members; 